<template>
  <div>
    <div class="set">
      <ul class="set-items">
        <li class="set-item set-item-next" @click="forget_url">修改密码</li>
        <li class="set-item" @click="exit">退出登录</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "me-setting",
  methods: {
    exit() {
      // function delCookie(name)
      // {
      //   var exp = new Date();
      //   exp.setTime(exp.getTime() - 1);
      //   var cval=getStorage(name);
      //   if(cval!=null)
      //     document.cookie= name + "="+cval+";expires="+exp.toGMTString();
      // }
      // delCookie('mooc_user_salt');
      // delCookie('mooc_user_token');
      // delCookie('mooc_user_id');
      // this.$router.push("/index");
      this.$api.get("", {
        api: "/api/proxy/logout",
        user_type: this.tools.getStorage("user_type")
      }, res => {
        if (res.status === 1) {
          localStorage.clear();
          this.$store.commit("setLogout");
          this.$store.commit("setLogin",0);
          this.$store.commit("setMyid",0);
          this.$store.commit("setMygroupIds",[]);
          this.$router.push("/index");
        }
      })
    },
    forget_url() {
      var url = window.location.protocol+'//'+document.domain + '/mooc-wx/login?v_key=' + geturl_j('v_key');
      window.location.href = 'http://passport2.chaoxing.com/pwd/getpwd?version=1&fid=-1&refer=' + encodeURIComponent(url);
    }
  }
}

function geturl_j(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
</script>

<style scoped>
.set-items {
  margin: 0 0.4rem;
}

.set-item {
  height: 1.68rem;
  border-bottom: 1px solid #e6e6e6;
  color: #333;
  font-size: 0.427rem;
  line-height: 1.68rem;
}

.set-item-next {
  background: url("../me/enter.png") 9.067rem center no-repeat;
  background-size: 0.133rem;
}
</style>



// WEBPACK FOOTER //
// src/components/me-setting/me-setting.vue